import {FC, useContext, useEffect, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";

import HubHeader from '../components/header';
import GuestTopHeader from "src/components/guestTopHeader";

import { AuthContext } from "../context/authContext";
import { AuthenticatedRoutes, ManufacturerRoutes, PublicRoutes ,ManufacturerRoutesWithoutEOB, AuthenticatedRoutesWithEoB} from "../routes/AppRoutes";
import { AppRoute } from "src/routes/types";
import { MANUFACTURER_ROUTES_BY_REF_TYPE } from "src/constants";
// import {USER_TYPES} from "../constants";


const WithHeaderandFooter: FC<{ WrappedComponent: FC }> = ({ WrappedComponent }): JSX.Element => {
  const [showBanner, setShowBanner] = useState(true)

  const { isUserAuthorized, isRestoreCalled, userData, isManufacturer, restoreSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const isSingleSignOn = localStorage.getItem("fromSingleSignOn")
  const handleCloseBanner = () => {
    setShowBanner(false); // will reset on refresh or revisit
  };


  const navigateToTargetedRoute = (RouteListing: AppRoute[]) => {
    const indexRoute = RouteListing.find((route) => route.isIndex);
    const currentRoute = RouteListing.find((route) => {
      const firstCheck = route.route.includes(pathname);
      if (route.route.includes(":")) {
        const checkForRoute = route.route.replace(/:([a-z]+)\/?/gi, "/").replace(/\//g, "");
        const checkForPathname = pathname.replace(/[0-9]/g, "").replace(/\//g, "");
        const secondCheck = checkForRoute === checkForPathname;
        return firstCheck || secondCheck;
      } else {
        return firstCheck;
      }
    });

    if (indexRoute && userData) {
      if (currentRoute) {
        if (userData.ref_type === "rep") {
          if (MANUFACTURER_ROUTES_BY_REF_TYPE.REP.includes(currentRoute.route)) {
            navigate(`/territories/${userData.id}`);
          } else {
            navigate(pathname + search)
          }
        } else if (userData.ref_type === "regional_manager") {
          if (MANUFACTURER_ROUTES_BY_REF_TYPE.REGIONAL_MANAGER.includes(currentRoute.route)) {
            navigate('/statistics' + search)
          } else {
            navigate(pathname + search)
          }
        } else if (userData.ref_type === "district_manager") {
          if (MANUFACTURER_ROUTES_BY_REF_TYPE.DISTRICT_MANAGER.includes(currentRoute.route)) {
            navigate('/statistics' + search)
          } else {
            navigate(pathname + search)
          }
        } else {
          navigate(pathname + search);
        }
      } else {
        navigate(indexRoute.route);
      }
    }
  }

  const checkForAuthentication = () => {
    if (!isUserAuthorized) {
      navigateToTargetedRoute(PublicRoutes);
    } else {
      if (isSingleSignOn) {
        if (isManufacturer) {
          navigateToTargetedRoute(( userData?.eob_button || userData?.ref_type === "fam_rm") ? ManufacturerRoutes : ManufacturerRoutesWithoutEOB);
        } else {
          navigateToTargetedRoute(userData && userData.eob_button ? AuthenticatedRoutesWithEoB : AuthenticatedRoutes);
        }
      } else {
        if (userData?.is_password_changed === false) {
          navigate("/users/createuser");
        } else if (isManufacturer) {
          navigateToTargetedRoute((userData?.eob_button || userData?.ref_type === "fam_rm") ? ManufacturerRoutes : ManufacturerRoutesWithoutEOB);
        } else {
          navigateToTargetedRoute(userData && userData.eob_button ? AuthenticatedRoutesWithEoB : AuthenticatedRoutes);
        }
      }
    }
  }

  useEffect(() => {
    if (isRestoreCalled) {
      checkForAuthentication();
    } else if (!userData) {
      restoreSession();
    } else {
      navigate(pathname + search);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRestoreCalled, isUserAuthorized]);




  return (
    <>
      <header className="bg-white sticky-top">
        {!isUserAuthorized ? (
          <GuestTopHeader />
        ) : null}
        <HubHeader />
      </header>
      <div>{showBanner && !isManufacturer && isUserAuthorized && (
        <div className="alert alert-warning auto-save-banner d-flex align-items-start justify-content-between">
          <div>
            <h4 className="alert-heading mb-2 fs-4">New Features Now Available on EXPAREL Support!</h4>
            <ol className="list-group flex-grow-1 ps-4" style={{fontSize:'18px'}}>
              <li className=""><b>EOB Warehouse – </b> Search & view actual payer EOB examples for coverage info or
                upload an EOB to add to our warehouse for sharing & we’ll de-identify your practice & patient information
                for you. Click on the EOB Warehouse button in the top menu bar for more details.
              </li>
              <li className=""><b>Case Details Report – </b> This easy-to-read Excel spreadsheet gives you a quick
                snapshot of your patient list including Case Status & Next Steps. Download a report today by clicking
                on the button in the “All Cases” section.
              </li>
            </ol>
          </div>
          <button type="button" className="btn bi bi-x-lg fs-5 p-0" onClick={handleCloseBanner}></button>
        </div>
      )}</div>
      <WrappedComponent />

       {/* {mountTawk ? <TawkToMessengerComp /> : null} */}

      {/* <HubFooter /> */}
    </>
  );
}


export default WithHeaderandFooter;
